import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { GasCostCalculator, HappyCallSafety, HappyCallIn, HappyCallOut, ApplyTalk } from '..';
import ErrorBoundary from '../components/ErrorBoundary';
import NotFound from '../components/NotFound';

class App extends Component {
    handleCreate = (data) =>{
        console.log(data);
    }
    render() {
        return (
            <ErrorBoundary>
            <div>
                <Switch>
                    <Route path="/HappyCallSafety/:cust_no/:effective_date" component={HappyCallSafety}/>
                    <Route path="/HappyCallSafety/:cust_no" component={HappyCallSafety}/>
                    <Route path="/HappyCallIn/:cust_no/:effective_date" component={HappyCallIn}/>
                    <Route path="/HappyCallIn/:cust_no/" component={HappyCallIn}/>
                    <Route path="/HappyCallOut/:cust_no/:effective_date" component={HappyCallOut}/>
                    <Route path="/HappyCallOut/:cust_no/" component={HappyCallOut}/>
                    <Route exact path="/ApplyTalk/:token/" component={ApplyTalk}/>
                    <Route exact path="/" component={GasCostCalculator}/>
                    <Route component={NotFound} />
                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}

export default App;